import type { TOC } from '@ember/component/template-only';

import BarLoaderComponent from 'webapp/components/bar-loader';

const ReportsEditorLoadingRouteTemplate: TOC<object> = <template>
	<div id="loading">
		<BarLoaderComponent @size="big" />

		<span class="bg-hack"></span>
	</div>
</template>;

export default ReportsEditorLoadingRouteTemplate;
